import React from "react";
import { MatchForm, Container, Indicator } from "./styles";

interface Props {
  form?: string[];
}

function FormIndicator({ form }: Props) {
  return (
    <Container>
      <MatchForm role="list">
        {form?.map((match, index) => (
          <Indicator role="listitem" result={match} key={index} />
        ))}
      </MatchForm>
    </Container>
  );
}

export default FormIndicator;
